export default [
  {
    path: 'properties',
    children: [
      {
        name: 'properties',
        path: '',
        component: () => import('./PropertiesList.vue'),
        meta: {
          title: 'Listings'
        }
      },
      {
        name: 'commercial-properties',
        path: 'commercial',
        component: () => import('./PropertiesList.vue'),
        meta: {
          title: 'Commercial'
        },
        props: {
          title: 'Commercial',
          // Always constrain this list to the commercial property_type column.
          customFilters: { property_types: 'commercial' },
          filterSuffix: '-commercial',
        }
      },
      {
        name: 'create-property',
        path: 'create',
        component: () => import('./PropertyForm.vue'),
        meta: {
          title: 'New Listing'
        },
        props: {
          type: 'New'
        }
      },
      {
        name: 'edit-property',
        path: ':id/edit',
        component: () => import('./PropertyForm.vue'),
        meta: {
          title: 'Edit Listing'
        },
        props: (route) => ({
          type: 'Edit',
          id: route.params.id
        })
      },
      {
        name: 'view-property',
        path: ':id/view',
        component: () => import('./PropertyView.vue'),
        meta: {
          title: 'View Listing'
        },
        props: (route) => ({
          id: route.params.id
        })
      }
    ]
  },
]
